
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyConicalSouth as ObiBuoyConicalSouthElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-conical-south.js';
 
 
 

 
 export const ObiBuoyConicalSouth = createComponent({
   react: React,
   tagName: 'obi-buoy-conical-south',
   elementClass: ObiBuoyConicalSouthElement,
   events: {
     
   }
  });
 
 